import { render } from "./ModalReset.vue?vue&type=template&id=632ebcf7&scoped=true"
import script from "./ModalReset.vue?vue&type=script&lang=js"
export * from "./ModalReset.vue?vue&type=script&lang=js"

import "./ModalReset.vue?vue&type=style&index=0&id=632ebcf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632ebcf7"]])

export default __exports__